import React, { useEffect, useState } from 'react';
import ServiceModule from '../../../services/KangarooServices/ServiceModule';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Badge,
  Button,
  Alert,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { imageBaseApi } from '../../../utilis/imageHelper';

const ServiceDetail = () => {
  const { slug } = useParams();
  const [details, setDetails] = useState(null);
  const [activeMainTab, setActiveMainTab] = useState('0');
  const [activeSubTab, setActiveSubTab] = useState({});
  const [openAccordion, setOpenAccordion] = useState('');

  const fetchDetails = async () => {
    try {
      const response = await ServiceModule.getBySlug(slug);
      setDetails(response);
      
      // Initialize first sub-tab for each main category
      if (response?.subDetails) {
        const initialSubTabs = {};
        response.subDetails.forEach((subDetail, index) => {
          initialSubTabs[index] = '0';
        });
        setActiveSubTab(initialSubTabs);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetails(slug);
  }, [slug]);

  const toggleMainTab = (tab) => {
    if (activeMainTab !== tab) {
      setActiveMainTab(tab);
    }
  };

  const toggleSubTab = (mainIndex, subTab) => {
    setActiveSubTab(prev => ({
      ...prev,
      [mainIndex]: subTab
    }));
  };

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? '' : id);
  };

  
  const createMarkup = (html) => {
    return { __html: html };
  };


  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb
          title={details?.name}
          pageTitle="Service"
          breadcrumbItems={[{ title: "Back to List", link: "/service" }]}
        />

        {/* Hero Banner Section */}
        <Card className="mb-4 border-0 shadow-sm">
          <div 
            className="position-relative"
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${imageBaseApi+details?.bannerMedia?.url})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '300px',
              borderRadius: '0.5rem'
            }}
          >
            <CardBody className="d-flex flex-column justify-content-center align-items-center text-center p-5">
              <h1 
                className="display-4 fw-bold" 
                style={{ color: details?.bannerTextColorCode || '#ffffff' }}
              >
                {details?.bannerText}
              </h1>
              {/* {details.bannerButtonText && (
                <p
                   
                  style={{ 
                    backgroundColor: details.bannerButtonColorCode || '#007bff',
                    borderColor: details.bannerButtonColorCode || '#007bff'
                  }}
                  className="mt-3 px-5"
                >
                  {details.bannerButtonText}
                </p>
              )} */}
            </CardBody>
          </div>
        </Card>

        {/* Main Description Section */}
        {details?.mainDescription && (
          <Card className="mb-4 border-0 shadow-sm">
            <CardBody className="p-4">
              <div dangerouslySetInnerHTML={createMarkup(details?.mainDescription)} />
            </CardBody>
          </Card>
        )}

        {/* Main Content with Tabs */}
        {details?.subDetails && details?.subDetails.length > 0 && (
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-white border-bottom">
              <h4 className="mb-0 text-primary">Visa Categories</h4>
            </CardHeader>
            <CardBody className="p-0">
              <Row className="g-0">
                {/* Vertical Tab Navigation */}
                <Col lg={3} className="border-end">
                  <Nav vertical pills className="p-3">
                    {details.subDetails.map((subDetail, index) => (
                      <NavItem key={subDetail.id} className="mb-2">
                        <NavLink
                          className={`${activeMainTab === String(index) ? 'active' : ''} rounded`}
                          onClick={() => toggleMainTab(String(index))}
                          style={{ cursor: 'pointer' }}
                        >
                          <i className="ri-folder-line me-2"></i>
                          <strong>{subDetail.title}</strong>
                          
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </Col>

                {/* Tab Content */}
                <Col lg={9}>
                  <TabContent activeTab={activeMainTab} className="p-4">
                    {details.subDetails.map((subDetail, mainIndex) => (
                      <TabPane key={subDetail.id} tabId={String(mainIndex)}>
                        {/* Category Description */}
                        {subDetail.description && (
                          <Alert color="info" className="mb-4">
                            <div dangerouslySetInnerHTML={createMarkup(subDetail.description)} />
                          </Alert>
                        )}

                        {/* Sub-category Tabs */}
                        {subDetail.subDetailsMenus && subDetail.subDetailsMenus.length > 0 && (
                          <>
                            <Nav tabs className="mb-3">
                              {subDetail.subDetailsMenus.map((menu, subIndex) => (
                                <NavItem key={menu.id}>
                                  <NavLink
                                    className={activeSubTab[mainIndex] === String(subIndex) ? 'active' : ''}
                                    onClick={() => toggleSubTab(mainIndex, String(subIndex))}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {menu.title}
                                    {menu.pdf && (
                                      <i className="ri-file-pdf-line ms-2 text-danger"></i>
                                    )}
                                  </NavLink>
                                </NavItem>
                              ))}
                            </Nav>

                            <TabContent activeTab={activeSubTab[mainIndex]}>
                              {subDetail.subDetailsMenus.map((menu, subIndex) => (
                                <TabPane key={menu.id} tabId={String(subIndex)}>
                                  <Card className="border shadow-sm">
                                    <CardBody>
                                      {/* Visa Title and PDF Download */}
                                      <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                          <h3 className="text-primary mb-2">{menu.title}</h3>
                                          {menu.description && (
                                            <div 
                                              className="text-muted mb-3"
                                              dangerouslySetInnerHTML={createMarkup(menu.description)} 
                                            />
                                          )}
                                        </div>
                                        {/* {menu.pdf && (
                                          <Button 
                                            color="danger" 
                                            outline 
                                            size="sm"
                                            href={menu.pdf.url}
                                            target="_blank"
                                          >
                                            <i className="ri-download-line me-1"></i>
                                            Download PDF
                                          </Button>
                                        )} */}
                                      </div>

                                      {/* Visa Details Accordion */}
                                      {/* {menu.contents && menu.contents.length > 0 ? (
                                        <Accordion open={openAccordion} toggle={toggleAccordion}>
                                          {menu.contents.map((content) => (
                                            <AccordionItem key={content.id}>
                                              <AccordionHeader targetId={content.id}>
                                                <i className="ri-information-line me-2 text-primary"></i>
                                                <strong>{content.heading}</strong>
                                                {content.subHeading && (
                                                  <small className="text-muted ms-2">
                                                    - {content.subHeading}
                                                  </small>
                                                )}
                                              </AccordionHeader>
                                              <AccordionBody accordionId={content.id}>
                                                {content.media && (
                                                  <div className="mb-3">
                                                    <img 
                                                      src={content.media.url} 
                                                      alt={content.heading}
                                                      className="img-fluid rounded"
                                                      style={{ maxHeight: '300px' }}
                                                    />
                                                  </div>
                                                )}
                                                
                                                <div 
                                                  className="content-description"
                                                  dangerouslySetInnerHTML={createMarkup(content.description)} 
                                                />

                                                {content.pdf && (
                                                  <div className="mt-3">
                                                    <Button 
                                                      color="primary" 
                                                      size="sm"
                                                      href={content.pdf.url}
                                                      target="_blank"
                                                    >
                                                      <i className="ri-file-pdf-line me-1"></i>
                                                      View Related Document
                                                    </Button>
                                                  </div>
                                                )}
                                              </AccordionBody>
                                            </AccordionItem>
                                          ))}
                                        </Accordion>
                                      ) : (
                                        <Alert color="warning" className="mb-0">
                                          <i className="ri-information-line me-2"></i>
                                          No detailed information available for this visa category.
                                        </Alert>
                                      )} */}
                                    </CardBody>
                                  </Card>
                                </TabPane>
                              ))}
                            </TabContent>
                          </>
                        )}
                      </TabPane>
                    ))}
                  </TabContent>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default ServiceDetail;